export const POEM = (
  <>
    I am inspired today
    <br/>to compliment your celebration
    <br/>But can't compete with you in prose
    <br/>directed into code my passion!
    <br/>
    <br/>My birthday girl, to you
    <br/>Concept of age does little sense
    <br/>You are too smol for it and true,
    <br/>Look at your skin and baby face!
    <br/>
    <br/>Your charm is so intense my wife
    <br/>But at the very bottom
    <br/>You sacrifice for me your life
    <br/>And that will not to be forgotten
    <br/>
    <br/>My brave and affectionate muse,
    <br/>That was a fortunate stroke I met you,
    <br/>My mission is to have good use
    <br/>In making sure you are protected.
    <br/>
    <br/>I wish you laughters and light mood
    <br/>Eat choco cake, so Led can join,
    <br/>I know your time will be all good,
    <br/>Cheers, Happy birthday, Be enjoying!
    <br/>
    <br/>
    <br/>Gosha, 2022
  </>
);
